<template>
  <v-date-picker
      class="table-singleInput"
      v-model="item.values"
      :locale="lang().locale"
      :firstDayOfWeek="2"
      :masks="lang().korean ? {
        title: 'YYYY년 MMMM',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['L', 'YYYY-MM-DD', 'YYYY-MM-DDTHH:mm:ss.sssZ', 'YYYY/MM/DD'],
        dayPopover: 'L',
        } : {}"
      :min-date="item.componentOptions.minDate ? item.componentOptions.minDate : null"
      :max-date="item.componentOptions.maxDate ? item.componentOptions.maxDate : null"
      :popover="{
        positionFixed : item.componentOptions ? item.componentOptions.positionFixed : false,
        placement : item.componentOptions ? item.componentOptions.popoverDirection : 'auto',
        visibility : item.componentOptions ?  item.componentOptions.popoverVisibility : 'focus'
      }"
  >
    <template v-slot="{ inputValue, inputEvents }">
      <input
          class="bg-white border px-2 py-1 rounded"
          :value="inputValue"
          :placeholder="lang().korean ? `YYYY.MM.DD` : `MM/DD/YYYY`"
          maxlength="8"
          v-on="inputEvents"
      />
    </template>
  </v-date-picker>
</template>
<script>
    export default {
      props: ['item'],
      data: () => {
        return {
          lang: () => {
            const language = navigator?.language || navigator?.userLanguage;
            const currentLang = localStorage.getItem('lang') ?? language;
            const korean = currentLang.includes('ko');
            const chinese = currentLang.includes('zh');
            const czech = currentLang.includes('cs');
            let locale = 'en'

            if (korean)
              locale = 'ko';
            // TODO: 중국어 운영 배포시 URL 체크 삭제
            else if (!window.location.href.includes('https://manager.rebless.clinic') && chinese)
              locale = 'zh-hk';
            // TODO: 체코어 운영 배포시 URL 체크 삭제
            else if (!window.location.href.includes('https://manager.rebless.clinic') && czech)
              locale = 'cs';

            return {
              korean: korean,
              locale: locale,
            }
          }
        }
      }
    }
</script>
<style lang="scss">
.bg-white {
    width: 100%;
}

.table-singleInput {
  input:focus {
    border: 1px solid var(--blue70);
  }

  input:disabled {
    background-color: var(--grey10) !important;
  }
}
</style>